import Modal from '@/components/modules/Modal';
import SwapSearch from '@/presentation/components/widgets/Swap/SwapSearch';
import { ShowSwapSearchModalProps } from '@/context/modal';

const SwapSearchModal = (props: ShowSwapSearchModalProps) => {
  return (
    <Modal
      size="lg"
      showCloseButton={false}
      clickOffToClose={true}
      offset="sm:ml-8 md:ml-[3.5rem]"
    >
      <SwapSearch {...props} />
    </Modal>
  );
};

export default SwapSearchModal;
